export const NaoClassificadosData = [
  {
    primeiroNome: 'da_sid',
    segundoNome: '.www.maersk.com',
    finalidade: '',
    validade: '30 minutos',
    processadorDados: '',
    linkPolitica: '',
  },
  {
    primeiroNome: 'da_intState',
    segundoNome: '.www.maersk.com',
    finalidade: '',
    validade: '30 minutos',
    processadorDados: '',
    linkPolitica: '',
  },
  {
    primeiroNome: 'da_lid',
    segundoNome: '.www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: '',
    linkPolitica: '',
  },
  {
    primeiroNome: 'intState',
    segundoNome: '.decibelinsight.net',
    finalidade: '',
    validade: '30 minutos',
    processadorDados: '',
    linkPolitica: '',
  },
]
